import { render, staticRenderFns } from "./TalkSection.vue?vue&type=template&id=41e40f80&scoped=true&"
import script from "./TalkSection.vue?vue&type=script&lang=js&"
export * from "./TalkSection.vue?vue&type=script&lang=js&"
import style0 from "./TalkSection.vue?vue&type=style&index=0&id=41e40f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e40f80",
  null
  
)

export default component.exports